import {connect} from 'react-redux';
import {createFragmentContainer, graphql} from 'react-relay';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  const report = _.find(state.reports, {id: ownProps.report.id}) || {};

  const deviceIds = report.deviceIds || [];
  let filteredDeviceIds = deviceIds;
  if (report.deviceIdsByTags && report.deviceIdsByTags.constructor === Array && report.deviceIdsByTags.length) {
    filteredDeviceIds = deviceIds.filter(id => report.deviceIdsByTags.find(d => d.id === id));
  }

  return {
    dateRange: report.dateRange,
    deviceIds: filteredDeviceIds,
    questionFilters: report.questionFilters,
  };
};

export default (WrappedComponent) => {
  const EnhancedComponent = connect(mapStateToProps)(WrappedComponent);
  
  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  EnhancedComponent.displayName = `WithReportFilterProps(${wrappedComponentName})`;
  
  return createFragmentContainer(
    EnhancedComponent,
    graphql`
      fragment withReportFilterProps_report on Report {
        id
        ...withWidgetData_report
      }
    `,
  );
};



// WEBPACK FOOTER //
// ./src/components/withReportFilterProps/withReportFilterProps.js